var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectedUndetermined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "2 2 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/SelectedUndetermined") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-designs-current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TP_DIY-TBA-Uncon-CurrentSearch-2.11",
    transform: "translate(-1506.000000, -850.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/SelectedUndetermined",
    transform: "translate(1506.500000, 850.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,3 C16.968,3 21,7.032 21,12 C21,16.968 16.968,21 12,21 C7.032,21 3,16.968 3,12 C3,7.032 7.032,3 12,3 Z M11.95,15.5 C11.6,15.5 11.304,15.621 11.062,15.863 C10.8206667,16.1043333 10.7,16.4 10.7,16.75 C10.7,17.1 10.8206667,17.3956667 11.062,17.637 C11.304,17.879 11.6,18 11.95,18 C12.3,18 12.596,17.879 12.838,17.637 C13.0793333,17.3956667 13.2,17.1 13.2,16.75 C13.2,16.4 13.0793333,16.1043333 12.838,15.863 C12.596,15.621 12.3,15.5 11.95,15.5 Z M12.1,6 C11.15,6 10.3793333,6.25 9.788,6.75 C9.196,7.25 8.78333333,7.85 8.55,8.55 L10.2,9.2 C10.2833333,8.9 10.471,8.575 10.763,8.225 C11.0543333,7.875 11.5,7.7 12.1,7.7 C12.6333333,7.7 13.0333333,7.84566667 13.3,8.137 C13.5666667,8.429 13.7,8.75 13.7,9.1 C13.7,9.43333333 13.6,9.74566667 13.4,10.037 C13.2,10.329 12.95,10.6 12.65,10.85 C11.9166667,11.5 11.4666667,11.9916667 11.3,12.325 C11.1333333,12.6583333 11.05,13.2666667 11.05,14.15 L12.9,14.15 C12.9,13.6 12.9626667,13.1666667 13.088,12.85 C13.2126667,12.5333333 13.5666667,12.1 14.15,11.55 C14.5833333,11.1166667 14.925,10.704 15.175,10.312 C15.425,9.92066667 15.55,9.45 15.55,8.9 C15.55,7.96666667 15.2083333,7.25 14.525,6.75 C13.8416667,6.25 13.0333333,6 12.1,6 Z",
    id: "Path-2",
    fill: "#0376A0"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedUndetermined);
export default __webpack_public_path__ + "static/media/SelectedUndetermined.7d6e85cc.svg";
export { ForwardRef as ReactComponent };